
// Common libraries: 
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
// Handle smooth scroll to element
import * as SmoothScroll from 'smooth-scroll/dist/smooth-scroll.js';


// Variable to store elements that has been scrolled to already
window.scrolledElements = [];

// Scroll to element given in link

// Get url hash
window.addEventListener("load", () => {
    // Scroll page to top
    let scroll = new SmoothScroll();
    scroll.animateScroll(
        0,
        0, {
        speedAsDuration: true,
        speed: 10,
        offset: 0,
    });


    setTimeout(() => {
        let hash = window.location.hash;

        if (hash.length > 0) {
            // Remove "#" from hash
            hash = hash.replace("#", "");

            // get only part from hash to ? if there are any tracking attributes
            hash = hash.split("?")[0];

            // Check if exists section with given data
            const scrollToElement = document.querySelector(`[id="${hash}"]`);

            if (scrollToElement) {
                // If element exists scroll to element

                let targetDistance = window.pageYOffset + scrollToElement.getBoundingClientRect().top;

                // Check if this target has been already scrolled
                if (window.scrolledElements.includes(hash)) {

                    if (window.innerWidth <= 991) {
                        targetDistance += 30
                    }
                    else {
                        targetDistance -= 10;
                    }
                }
                else {
                    window.scrolledElements.push(hash);
                    targetDistance -= 20
                }


                if (window.innerWidth <= 991) {
                    targetDistance -= 130;
                }
                else {
                    targetDistance -= 100;
                }


                setTimeout(() => {

                    // Scroll to start of it
                    let scroll = new SmoothScroll();
                    scroll.animateScroll(
                        targetDistance,
                        0, {
                        speedAsDuration: true,
                        speed: 650,
                        offset: 100,
                    });
                }, 100);
            }
        }
    }, 2000);
})

// Handle scroll to element, when url starts with #
// Handle 'Check all filters' button
$("body").on("click", "[href^='#']", function (e) {
    e.preventDefault();
    let element = $(this);

    let hash = element[0].getAttribute("href");

    // Remove "#" from hash
    hash = hash.replace("#", "");

    // get only part from hash to ? if there are any tracking attributes
    hash = hash.split("?")[0];

    // Check if exists section with given data
    const scrollToElement = document.querySelector(`[id="${hash}"]`);

    let targetDistance = window.pageYOffset + scrollToElement.getBoundingClientRect().top;

    // Check if this target has been already scrolled
    if (window.scrolledElements.includes(hash)) {
        if (window.innerWidth <= 991) {
            targetDistance += 30
        }
        else {
            targetDistance -= 10;
        }
    }
    else {
        window.scrolledElements.push(hash);
        targetDistance -= 20

    }


    if (window.innerWidth <= 991) {
        targetDistance -= 130;
    }
    else {
        targetDistance -= 100;
    }

    // Scroll to start of it
    let scroll = new SmoothScroll();
    scroll.animateScroll(
        targetDistance,
        0, {
        speedAsDuration: true,
        speed: 650,
        offset: 100,
    });
});